
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop list   列表数据
*/
@Component({
    name: 'winpress-demand-list-table'
})
export default class extends Vue {
    @Prop({ default: () => [] }) private list!: any[]

    private onStatusChange(status: number, item: any) {
        this.$emit('status-change', {
            status,
            item
        })
    }
}
